import { useState, useEffect } from "react";
import { LOGOS } from "../lib/api";
import { Menu, X, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

const navItems = [
  { label: "Home", href: "/#home" },
  { label: "Courses", href: "/#courses" },
  { label: "Verify", href: "/#verify" },
  { label: "Our Words", href: "/#mission" },
  { label: "Gallery", href: "/#gallery" },
  { label: "Contact", href: "/#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all ${
        scrolled
          ? "bg-[#F9F8F6]/90 backdrop-blur-xl border-b border-border shadow-sm"
          : "bg-transparent"
      }`}
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
          <img src={LOGOS.main} alt="EDSW" className="w-12 h-12 object-contain bg-white rounded-full p-1 border border-border" />
          <div className="hidden sm:block">
            <div className="font-serif-display text-xl font-semibold text-[#1B4332] leading-tight">EDSW Foundation</div>
            <div className="text-[10px] text-muted-foreground tracking-widest uppercase">Education • Development</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm font-medium text-[#222B26] hover:text-[#E07A5F] transition-colors relative group"
              data-testid={`nav-${item.label.toLowerCase().replace(" ", "-")}`}
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#E07A5F] group-hover:w-full transition-all" />
            </a>
          ))}
          <Link
            to="/admin/login"
            className="inline-flex items-center gap-2 bg-[#1B4332] text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-[#2D6A4F] transition-colors"
            data-testid="header-admin-btn"
          >
            <ShieldCheck className="w-4 h-4" /> Admin
          </Link>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden p-2 rounded-md hover:bg-muted"
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-[#F9F8F6]" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="block text-sm font-medium py-2 text-[#222B26]"
              >
                {item.label}
              </a>
            ))}
            <Link
              to="/admin/login"
              className="inline-flex items-center gap-2 bg-[#1B4332] text-white px-4 py-2 rounded-full text-sm font-medium"
            >
              <ShieldCheck className="w-4 h-4" /> Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
